import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as AppTokenUtil from '../util/AppTokenUtil';
import { Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';

class ConsentMicrosoft extends Component {
    state = {
        adminConsent: undefined,
        accessDenied: false,
        error: false,
    }

    login = async () => {
        this.setState({ error: false, adminConsent: undefined, accessDenied: false })

        let uri = this.props.data.uri;
        let login = await AppTokenUtil.authWindow(uri);

        if (login.admin_consent === 'True') {
            this.setState({ adminConsent: true });
        } else if (login.error === 'access_denied') {
            this.setState({ accessDenied: true });
        } else {
            this.setState({ error: true });
        }
    }

    render() {
        const { t } = this.props;
        const { adminConsent, accessDenied, error } = this.state;

        if (adminConsent) {
            return (
                <div>
                    <h5>{t('consent.microsoft.confirm', { ns: 'common' })}</h5>
                    <p>{t('consent.microsoft.itMightTakeAWhile', { ns: 'common' })}</p>
                </div>);
        } else if (accessDenied) {
            return (
                <p>{t('consent.microsoft.permissionMissingForTenant', { ns: 'common' })}</p>);
        } else if (error) {
            return (
                <div>
                    <p>{t('consent.microsoft.somethingWentWrongTryAgain', { ns: 'common' })}</p>
                    <Button className="btn-primary" disabled={this.props.disabled} onClick={this.login}>{t('consent.microsoft.logInToAcceptPermissions', { ns: 'common' })}</Button>
                </div>);
        } else {
            return (
                <div>
                    <p>{t('consent.microsoft.giveAccess', { ns: 'common' })}</p>
                    <Button className="btn-primary" onClick={this.login}>{t('consent.microsoft.logInToAcceptPermissions', { ns: 'common' })}</Button>
                </div>
            )
        }
    }
}

const mapStateToProps = state => ({
})

export default withTranslation('common')(connect(mapStateToProps, {})(ConsentMicrosoft));
